/**
 * Champions Dashboard - Welcome/Overview Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { WelcomeOverview } from '../../components/champions/dashboard/WelcomeOverview';

export function ChampionsDashboardPage() {
  // TODO: Replace with actual Champion data from backend/store
  const mockChampionData = {
    championName: 'Sarah Johnson',
    championNumber: 3,
    totalChampions: 10,
    daysActive: 14,
    neighborsReached: 12,
    feedbackCollected: 8,
    featureIdeasSubmitted: 2,
    currentPhase: 'feedback' as const,
  };

  return (
    <ChampionsDashboardLayout
      championName={mockChampionData.championName}
      championNumber={mockChampionData.championNumber}
    >
      <WelcomeOverview {...mockChampionData} />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsDashboardPage;
